import { RetAPI, GrupoTrib, CstICMS, error99 } from '../../Utils/Types'
import { Api } from '../../Utils/api'
import { v4 as uuid } from 'uuid'
import { encode as base64_encode } from 'base-64'

export type GrupoTribAttributes = {
    grupoTrib: GrupoTrib,
    cstList: CstICMS[],
}

export const TributacaoService = {

    GetAttributes: async (id?: string): Promise<RetAPI> => {

        const resp = await Api('GrupoTrib/attributes', 'get', { id })
        const grupoTrib: GrupoTrib = {
            id: 0,
            descricao: '',
            pICMS: 0,
            pPIS: 0,
            pCOFINS: 0,
            cstPisCofins: '',
            cfopSDentro: '',
            cfopSFora: '',
            cfopEdentro: '',
            cfopEfora: '',
            cstICMSDentro: '',
            cstICMSFora: '',
            dt_cadastro: '',
            id_user_insert: 0,
            name_user_insert: '',
            dt_last_update: '',
            name_user_last_update: '',
            description: ''
        }

        let retorno: GrupoTribAttributes = { grupoTrib: grupoTrib, cstList: [] }

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {

                return {
                    error: true,
                    msg: resp.data.msg || '',
                    data: retorno
                }
            }

            if (resp.data.error && resp.data.error === '0') {

                if (resp.data.trib) {

                    grupoTrib.id = resp.data.trib.id
                    grupoTrib.descricao = resp.data.trib.descricao
                    grupoTrib.pICMS = resp.data.trib.pICMS
                    grupoTrib.pPIS = resp.data.trib.pPIS
                    grupoTrib.pCOFINS = resp.data.trib.pCOFINS
                    grupoTrib.cstPisCofins = resp.data.trib.cst_pis_cofins
                    grupoTrib.cfopSDentro = resp.data.trib.cfop_saida_dentro
                    grupoTrib.cfopSFora = resp.data.trib.cfop_saida_fora
                    grupoTrib.cfopEdentro = resp.data.trib.cfop_entrada_dentro
                    grupoTrib.cfopEfora = resp.data.trib.cfop_entrada_fora
                    grupoTrib.cstICMSDentro = resp.data.trib.cst_icms_dentro
                    grupoTrib.cstICMSFora = resp.data.trib.cst_icms_fora
                    grupoTrib.dt_cadastro = resp.data.trib.dt_cadastro
                    grupoTrib.id_user_insert = resp.data.trib.id_user_insert
                    grupoTrib.name_user_insert = resp.data.trib.name_user_insert
                    grupoTrib.dt_last_update = resp.data.trib.dt_last_update
                    grupoTrib.name_user_last_update = resp.data.trib.name_user_last_update
                    grupoTrib.description = resp.data.trib.descricao

                    retorno.grupoTrib = grupoTrib

                }

                if (resp.data.csts) {
                    retorno.cstList = resp.data.csts.map((item: any) => {
                        return {
                            id: item.cod_cst,
                            cod_cst: item.cod_cst,
                            description: item.descricao,
                        }
                    })
                }
            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada",
                data: retorno
            }
        }

        return {
            error: false,
            data: retorno
        }

    },

    Save: async (trib: GrupoTrib): Promise<RetAPI> => {

        let id = ''

        if (trib.id) {
            id = trib.id.toString()
        }

        const resp = await Api('GrupoTrib/save', 'post', {

            descricao: trib.descricao,
            pICMS: trib.pICMS,
            pPIS: trib.pPIS,
            pCOFINS: trib.pCOFINS,
            CST_PIS_COFINS: trib.cstPisCofins,
            CFOP_SAIDA_DENTRO: trib.cfopSDentro,
            CFOP_SAIDA_FORA: trib.cfopSFora,
            CFOP_ENTRADA_DENTRO: trib.cfopEdentro,
            CFOP_ENTRADA_FORA: trib.cfopEfora,
            CST_ICMS_DENTRO: trib.cstICMSDentro,
            CST_ICMS_FORA: trib.cstICMSFora,
            id

        })

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',
                    field: resp.data.field
                }
            }

            return {
                error: false,
                msg: 'Dados da Tributação gravados com sucesso',
                id: resp.data.trib.id,
                data: resp.data,
                dt_cadastro: resp.data.trib.dt_cadastro,
                dt_last_update: resp.data.trib.dt_last_update,
                name_user_insert: resp.data.trib.name_user_insert,
                name_user_last_update: resp.data.trib.name_user_last_update,
            }

        } else {
            return {
                error: true,
                msg: "Nenhuma informação retornada"
            }
        }

    },

    Delete: async (idExcluir: number, motivo: string, senha: string): Promise<RetAPI> => {

        const random = uuid()

        senha = base64_encode(senha + '-' + random)

        const resp = await Api(`GrupoTrib/delete?id=${idExcluir}&motivo=${motivo}&senha=${senha}`, 'delete')

        if (!resp.data) {
            return {
                error: true,
                msg: "Nenhuma informação retornada"
            }
        }

        if (resp.data.error && resp.data.error === '99') {
            error99()
        }

        if (resp.data.error && resp.data.error === '1') {
            return {
                error: true,
                msg: resp.data.msg || ''
            }
        }

        return {
            error: false,
            msg: '',
        }

    },

    Filter: async (field: string, filter_type: string, filter: string, id?: string): Promise<RetAPI> => {

        const resp = await Api('GrupoTrib/filter', 'get', { field, filter_type, filter, id })
        const tributacao: GrupoTrib[] = []

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {

                return {
                    error: true,
                    msg: resp.data.msg || '',
                    data: tributacao
                }
            }

            if (resp.data.error && resp.data.error === '0') {
                resp.data.grupo_trib.map((item: any) => {
                    return tributacao.push({
                        id: item.id,
                        descricao: item.descricao,
                        pICMS: item.pICMS,
                        pPIS: item.pPIS,
                        pCOFINS: item.pCOFINS,
                        cstPisCofins: item.cst_pis_cofins,
                        cfopSDentro: item.cfop_saida_dentro,
                        cfopSFora: item.cfop_saida_fora,
                        cfopEdentro: item.cfop_entrada_dentro,
                        cfopEfora: item.cfop_entrada_fora,
                        cstICMSDentro: item.cst_icms_dentro,
                        cstICMSFora: item.cst_icms_fora,
                        dt_cadastro: item.dt_cadastro,

                        id_user_insert: item.id_user_insert,
                        name_user_insert: item.name_user_insert,
                        dt_last_update: item.dt_last_update,
                        name_user_last_update: item.name_user_last_update,

                        description: item.descricao

                    })
                });

            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada",
                data: tributacao
            }
        }

        return {
            error: false,
            data: tributacao,
        }

    },

    Relatorio: async (datai: string, dataf: string, descricao?: string, mostrar_excluidas?: string): Promise<RetAPI> => {

        const resp = await Api('GrupoTrib/Report/relatorio', 'get', { datai, dataf, descricao, mostrar_excluidas })
        const trib: any[] = []

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {

                return {
                    error: true,
                    msg: resp.data.msg || '',
                    data: trib
                }
            }

            if (resp.data.error && resp.data.error === '0') {

                resp.data.grupo_trib.map((item: any) => {
                    return trib.push({

                        id: item.id,
                        id_user_exclusao: item.id_user_exclusao,
                        dh_exclusao: item.dh_exclusao,
                        motivo_exclusao: item.motivo_exclusao,
                        name_user_delete: item.name_user_delete,
                        descricao: item.descricao,

                    })
                })
            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada",
                data: trib
            }

        }

        return {
            error: false,
            data: trib,
        }

    }
}